import { render, staticRenderFns } from "./CallAction.vue?vue&type=template&id=6a31a110&scoped=true&"
import script from "./CallAction.vue?vue&type=script&lang=js&"
export * from "./CallAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31a110",
  null
  
)

export default component.exports